:host {
  --row-border-bottom: 1px solid var(--chart-101-pressed-dividers);
  --item-name-width: 50%;
}

.row {
  display: flex;
  align-items: center;
  height: calc(var(--spacer) * 4);
  border-bottom: var(--row-border-bottom);
  cursor: default;
  justify-content: space-between;

  .item-info {
    display: flex;
    justify-content: space-between;
    width: var(--item-name-width);
    max-width: 376px;
    min-width: 0;
    color: var(--main-titles-inputs-600);

    .item-name {
      display: inline;
      font-family: var(--font-family-secondary);
      font-size: var(--body-size-large);
      color: var(--main-titles-inputs-600);
    }
  }

  .percentage-value {
    width: 22px !important;
    display: flex;
    justify-content: end;
    color: var(--green-layout-100-primary-green);
    --font-family: var(--font-family-secondary-mono);
    width: fit-content;
  }

  .empty-value,
  .icon-value {
    color: var(--main-titles-inputs-600);
  }

  .icon-value {
    width: 22px;
    margin-right: calc(var(--spacer) / 2);
    font-weight: 500;
    --font-family: var(--font-family-secondary-mono);
  }

  .icon-value:last-of-type {
    margin-right: unset;
  }
}

gz-icon {
  padding-right: 6px;
}

:host([state='is-active']:hover) {
  cursor: pointer;

  .item-info,
  .item-name,
  .percentage-value,
  .empty-value,
  .icon-value {
    color: var(--blue-layout-400-primary);
  }

  .svg-icon {
    fill: var(--blue-layout-400-primary);
  }

  gz-icon::part(svgIcon) {
    fill: var(--blue-layout-400-primary);
  }
}
